__webpack_require__.p = "https://sport2.surebet247.com/xsportapp/xsport_desktop_surebet/";